// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__swX0g","list":"styles_list__DLbBq","active":"styles_active__OrD9P"};